import React from "react";
export default class MrlSingleReview extends React.Component{
    render(){
        return this.props.state.reviews.map((el, i) => {
            var color = this.props.color();
            var border = "2px solid " + color;

            var stars = (
                [0,1,2,3,4,5].map(i => {
                    if(i > 0)
                    {
                        if(i <= el.stars)
                            return <i className="bi bi-star-fill" key={i}></i>
                        return <i className="bi bi-star" key={i}></i>
                    }
                    return ""											
                })
            );

            var date = new Date(Date.parse(el.date));
            date = date.toLocaleDateString('it-IT', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

            return(
                <div className="col" key={el.r_id}>
                    <div className="card" style={{border:border,backgroundColor:color}} >												
                        <div className="card-body" style={{color:'gold', backgroundColor:'rgba(0,0,0,0.1)'}}>
                            {stars}
                        </div>
                        <div className="card-body pt-5 pb-5">
                            <figure className="text-center">
                                <blockquote className="blockquote pb-3">
                                    <p>{el.piaciuto}</p>
                                </blockquote>
                                <figcaption className="blockquote-footer">
                                    {el.nome} {el.cognome}<br/><cite title={el.nome_corso}>{el.nome_corso}{el.luogo_corso? ' - ' + el.luogo_corso : ''}</cite>
                                </figcaption>
                            </figure>
                        </div>
                        <div className="card-footer text-muted footer-review">
                            {date}
                            {el.link ? <>&nbsp;<a href={el.link} target="_blank" rel="noopener noreferrer">{el.link}</a></> : ''}
                        </div>
                    </div>
                </div>
            )
        })
    }
}